import { Link, useParams } from 'react-router-dom';
import NewsCard from '@/components/feature/NewsCard';
import SectionHeading from '@/components/feature/SectionHeading';
import EmptyState from '@/components/feature/EmptyState';
import { newsList } from '@/mocks/news';

export default function NewsDetail() {
  const { id } = useParams();
  const article = newsList.find((n) => n.id === id);

  if (!article) {
    return (
      <div className="w-full bg-background-50 min-h-[60vh] flex items-center justify-center px-4">
        <EmptyState
          icon="ri-newspaper-line"
          title="新闻不存在"
          description="你访问的资讯可能已下线或链接有误。"
          actionLabel="返回资讯列表"
          onAction={() => window.REACT_APP_NAVIGATE?.('/news')}
        />
      </div>
    );
  }

  const related = newsList.filter((n) => n.id !== article.id).slice(0, 4);

  return (
    <div className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-8 md:py-10">
        <div className="max-w-screen mx-auto">
          <nav className="text-xs md:text-sm text-foreground-600 mb-6 flex items-center gap-1.5 flex-wrap">
            <Link to="/" className="hover:text-primary-400 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/news" className="hover:text-primary-400 transition-colors">电影资讯</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-800 truncate max-w-[200px]">{article.title}</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-10">
            <article className="min-w-0">
              <div className="flex items-center gap-3 text-xs text-foreground-600 mb-3">
                <span className="px-2.5 py-1 rounded bg-secondary-800 text-secondary-200">{article.category}</span>
                <span>{article.date}</span>
                <span>作者：{article.author}</span>
              </div>

              <h1 className="text-2xl md:text-3xl font-black text-foreground-950 leading-snug mb-3">{article.title}</h1>
              <p className="text-sm md:text-base text-foreground-600 mb-6">{article.subtitle}</p>

              <div className="w-full aspect-[16/9] rounded-lg overflow-hidden bg-background-200 mb-8">
                <img
                  src={article.cover}
                  alt={`${article.title} 配图`}
                  title={`${article.title} - 资讯全文`}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="space-y-5">
                {article.content.map((paragraph, idx) => (
                  <p key={idx} className="text-sm md:text-base text-foreground-700 leading-loose">
                    {paragraph}
                  </p>
                ))}
              </div>

              <div className="mt-10 pt-6 border-t border-background-300/50 flex flex-wrap items-center justify-between gap-3">
                <p className="text-xs text-foreground-600">本文为演示内容，仅用于展示网站功能。</p>
                <Link
                  to="/news"
                  className="text-sm text-foreground-700 hover:text-primary-400 transition-colors flex items-center gap-1 whitespace-nowrap"
                >
                  <i className="ri-arrow-left-s-line"></i> 返回资讯列表
                </Link>
              </div>
            </article>

            <aside className="lg:sticky lg:top-24 h-fit">
              <h2 className="text-base font-bold text-foreground-950 mb-4 flex items-center gap-2">
                <i className="ri-book-open-line text-primary-500"></i> 相关阅读
              </h2>
              <div className="space-y-3">
                {related.map((item) => (
                  <NewsCard key={item.id} article={item} />
                ))}
              </div>
            </aside>
          </div>

          <section className="mt-14 pb-14">
            <SectionHeading title="更多资讯推荐" moreTo="/news" />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
              {related.map((item) => (
                <NewsCard key={`bottom-${item.id}`} article={item} />
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}